import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ReactComponent as ArrowLeft } from '../../../Assets/images/arrow-left.svg';
import { ReactComponent as ArrowRight } from '../../../Assets/images/arrow-right.svg';
const LotCardCarousel = ({ images }) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    return (React.createElement(Swiper, { resizeObserver: true, updateOnWindowResize: true, onSwiper: (swiper) => {
            // @ts-ignore
            swiper.params.navigation.prevEl = prevRef.current;
            // @ts-ignore
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
        }, modules: [Navigation], className: "lot-card-carousel" },
        React.createElement("div", null, images &&
            images.map((item, index) => (React.createElement(SwiperSlide, { key: `slide-${index}` },
                React.createElement("img", { alt: `slide-${index}`, src: item }))))),
        images && images?.length > 1 && (React.createElement("div", { className: "lot-card-carousel__navigation" },
            React.createElement("button", { className: "lot-card-carousel__btn", ref: prevRef },
                React.createElement(ArrowLeft, null)),
            React.createElement("button", { className: "lot-card-carousel__btn", ref: nextRef },
                React.createElement(ArrowRight, null))))));
};
export default LotCardCarousel;
